import { GridRowModel } from '@mui/x-data-grid';
import { AclEntriesCommonTooltip } from 'common/components/sharedCustomComponents/AclEntriesCommonTooltip/AclEntriesCommonTooltip';
import {
    ActionDefinition,
    ColumnDefinition,
    ColumnType,
    Operations
} from 'common/types/TypeDefs';

const DEFAULT_USER_ACL_ENTRIES_COLUMNS: ColumnDefinition[] = [
    { columnId: 'resourceId', columnName: 'ACL Resource ID', columnType: ColumnType.First, copy: true, shouldFilterByExactMatch: true },
    { columnId: 'resourceTableName', columnName: 'ACL Resource', columnType: ColumnType.Tooltip, copy: false },
    { columnId: 'conditionsToDisplay', columnName: 'ACL Condition', columnType: ColumnType.Tooltip, copy: false },
    { columnId: 'accessId', columnName: 'ACL Access ID', columnType: ColumnType.Tooltip, copy: true, shouldFilterByExactMatch: true },
    { columnId: 'accessTableName', columnName: 'ACL Access', columnType: ColumnType.Tooltip, copy: false },
    { columnId: 'actions', columnName: 'Action', columnType: ColumnType.Action, size: 0.5 }
];

const USER_ACL_ENTRIES_WITH_LICENSE_INFO: ColumnDefinition[] = [
    { columnId: 'resourceTableName', columnName: 'ACL Resource', columnType: ColumnType.First, copy: true },
    { columnId: 'conditionsToDisplay', columnName: 'ACL Condition', columnType: ColumnType.Tooltip, copy: false },
    { columnId: 'accessTableName', columnName: 'ACL Access', columnType: ColumnType.Tooltip, copy: false },
    { columnId: 'licenseBillingRecord', columnName: 'License', columnType: ColumnType.Tooltip },
    { columnId: 'startDate', columnName: 'ACL Start Date', columnType: ColumnType.DatetimeTooltip, size: 0.9 },
    { columnId: 'endDate', columnName: 'ACL End Date', columnType: ColumnType.DatetimeTooltip, size: 0.9 },
    {
        columnId: 'status',
        columnName: 'ACL Status',
        columnType: ColumnType.Chip,
        copy: false,
        sortable: false,
        size: 99,
        toolTip: AclEntriesCommonTooltip
    },
    { columnId: 'actions', columnName: 'Action', columnType: ColumnType.Action, size: 0.5 }
];

export const _createUserAclEntriesDataGridColumns = (
    isLicenseRequired?: boolean
): ColumnDefinition[] => isLicenseRequired ?
    USER_ACL_ENTRIES_WITH_LICENSE_INFO :
    DEFAULT_USER_ACL_ENTRIES_COLUMNS;

export const _createUserAclEntriesActionDefinitions = (
    shouldDisableButtons: boolean,
    disableEditActionCallback: (row: GridRowModel) => boolean,
): ActionDefinition[] => {
    return  [
        { action: Operations.Delete, disabled: shouldDisableButtons },
        { action: Operations.Edit, disabled: disableEditActionCallback }
    ];
};
